export const badCountryCodes = ['KP', 'CU', 'SD', 'SY', 'IR', 'LY'];
